import {SET_OTP_ENABLED} from '../constants/actionTypes';
import initialState from './initialState';
import _ from "lodash";

export default function otpEnabledReducer(state = initialState.otpEnabled, action) {
  switch (action.type) {
    case SET_OTP_ENABLED:
      return _.get(action, 'otpEnabled', false);
    default:
      return state;
  }
}


